export default {
	name : "managers_parking",
	data : (vm) => ({

	}), // data

	created(){

	},
	
	computed :{

	}, // computed

	methods : {


	}, // methods	
	
	mounted(){

	}, // mounted
}; // export default